import { FormDataConsumer, maxLength, ReferenceInput, required, SelectInput, TextInput } from "react-admin";
import { Grid } from "@mui/material";

import { settings } from "app";
import { SectionTitle } from "features/SectionTitle";
import CustomDateInput from "server/components/Fields/CustomDateInput";
import { administrationRequests } from "api/administrationApi";
import DegreeInput from "components/Campaigns/components/Inputs/DegreeInput";

const GraduationForm = ({ isMobile }) => {
  return (
    <Grid
      container
      spacing={2}
      sx={isMobile ? settings.style.shadowBoxMobile : settings.style.shadowBox}
    >
      <Grid
        item
        xs={12}
      >
        <SectionTitle
          title={"Информация за дипломиране"}
          paddingY={0}
        />
      </Grid>
      <Grid
        item
        xs={12}
        md={6}
        xl={4}
      >
        <TextInput
          source="university"
          label="Университет"
          validate={[required()]}
          fullWidth
        />
      </Grid>
      <Grid
        item
        xs={12}
        md={6}
        xl={4}
      >
        <DegreeInput source="graduationDegreeId" />
      </Grid>
      <Grid
        item
        xs={12}
        md={6}
      >
        <ReferenceInput
          source="graduationSpecialityId"
          reference={administrationRequests.getSpecialitiesSelect()}
          readOnly
        >
          <SelectInput
            label="Специалност"
            optionText="name"
          />
        </ReferenceInput>
      </Grid>
      <Grid
        item
        xs={12}
        md={6}
        xl={4}
      >
        <CustomDateInput
          fullWidth
          noTime
          validate={required("Задължително")}
          required
          source="diplomaDate"
          label="Дата на дипломиране"
        />
      </Grid>
      <FormDataConsumer>
        {({ formData }) => (
          <>
            <Grid
              item
              xs={12}
              md={6}
              xl={4}
            >
              <TextInput
                source="diplomaNumber"
                label="Номер на диплома"
                validate={[required(), maxLength(100)]}
                inputProps={{ maxLength: 100 }}
                helperText={`${formData?.diplomaNumber?.length || 0}/100`}
                error={(formData?.diplomaNumber?.length || 0) > 100}
                fullWidth
              />
            </Grid>
            <Grid
              item
              xs={12}
              md={6}
              xl={4}
            >
              <TextInput
                source="diplomaRegistrationNumber"
                label="Рег. Номер на диплома"
                validate={[required(), maxLength(100)]}
                fullWidth
                inputProps={{ maxLength: 100 }}
                helperText={`${formData?.diplomaRegistrationNumber?.length || 0}/100`}
                error={(formData?.diplomaRegistrationNumber?.length || 0) > 100}
              />
            </Grid>
            <Grid
              item
              xs={12}
              md={6}
              xl={4}
            >
              <TextInput
                source="diplomaSeries"
                label="Диплома серия"
                inputProps={{ maxLength: 50 }}
                helperText={`${formData?.diplomaSeries?.length || 0}/50`}
                error={(formData?.diplomaSeries?.length || 0) > 50}
                validate={[required(), maxLength(50)]}
                fullWidth
              />
            </Grid>
          </>
        )}
      </FormDataConsumer>
      <Grid
        item
        xs={12}
        md={6}
        xl={4}
      >
        <TextInput
          source="higherEducationRecognitionCert"
          label="Удостоверение за признато висше образование"
          fullWidth
        />
      </Grid>
      <Grid
        item
        xs={12}
        md={6}
        xl={4}
      >
        <TextInput
          label="Удостоверение за признаване на професионална квалификация"
          source="qualificationRecognitionCert"
          fullWidth
        />
      </Grid>
    </Grid>
  );
};
export default GraduationForm;
